/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React, { useRef, useEffect, useState } from 'react'
import "./practiceRFIBPage.scss"
import {drop, allowDrop} from './rfib'

export default function Blanks({lastStatus}){
    return(
        <>
        <div className='blanks' onDrop={drop} onDragOver={allowDrop}
            style={lastStatus === true ? { display: "none" } : { display: "inline-block" }}>
        </div>
        </>
    )
}